import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { me, loginAdmin as apiLoginAdmin, loginOperativo as apiLoginOperativo } from "@/services/authService";
import { warmUpAI } from "@/lib/aiWarmup";
import { setActiveTimeZone } from "@/lib/datetime";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("pap_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await me();
      setUser(data);
      if (data && data.zona_horaria) setActiveTimeZone(data.zona_horaria);
    } catch {
      localStorage.removeItem("pap_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Sprint 41.0 — al haber sesión autenticada, calienta la IA una sola vez por sesión (silencioso).
  useEffect(() => {
    if (user && user !== false) warmUpAI();
  }, [user]);

  const loginAdmin = async (email, password) => {
    const { data } = await apiLoginAdmin(email, password);
    localStorage.setItem("pap_token", data.access_token);
    if (data.user && data.user.zona_horaria) setActiveTimeZone(data.user.zona_horaria);
    setUser(data.user);
    return data.user;
  };

  const loginOperativo = async (codigo_operativo, usuario_corto, nip_acceso) => {
    const { data } = await apiLoginOperativo(codigo_operativo, usuario_corto, nip_acceso);
    localStorage.setItem("pap_token", data.access_token);
    if (data.user && data.user.zona_horaria) setActiveTimeZone(data.user.zona_horaria);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pap_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginAdmin, loginOperativo, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
